import Vue from 'vue';

import MdIcon from '../components/Ui/MdIcon.vue';
Vue.component('MdIcon', MdIcon);
